import { PrimaryButton } from "./PrimaryButton";
import { scrollToId } from "./motion";

export const Footer = () => (
  <footer data-testid="footer" className="bg-mushroom-deep text-oat px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
    <div className="max-w-[1200px] mx-auto">
      <h2 className="font-display font-black lowercase tracking-tighter leading-[0.85] text-[14vw] sm:text-[9vw] lg:text-[7vw]">
        coffee, create<br />&amp; community
      </h2>
      <div className="mt-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8">
        <p className="max-w-md text-base sm:text-lg font-medium leading-[1.3] text-oat/80">
          an in-person gathering for women who are building, creating, or moving something forward.
          thump at the grove · bend, oregon.
        </p>
        <PrimaryButton testId="footer-save-spot" onClick={() => scrollToId("rsvp")}>
          save my spot
        </PrimaryButton>
      </div>
      <p className="mt-3 text-sm font-semibold text-oat/70" data-testid="footer-free-note">
        free to RSVP
      </p>
      <p className="mt-16 text-xs uppercase tracking-[0.2em] text-oat/50">
        921 NW Mount Washington Dr, Bend, OR 97703
      </p>
    </div>
  </footer>
);
